import gql from "graphql-tag";

const field = `
id
numberOrder
name
description
createdAt
updatedAt
`;

const getAllAppInPlatformGroup = gql`
  {
    getAllAppInPlatformGroup {
      ${field}
    }
  }
`;

export default { getAllAppInPlatformGroup };
